/**
 * True for connection-level failures (offline, dropped connection, timeout):
 * the request never got a server response. These carry no actionable signal
 * for us — log them at debug, not error, so they stay out of Sentry.
 * A response with an error status (4xx/5xx) is NOT a network error.
 */
export function isNetworkError(error: unknown): boolean {
  const err = error as {
    code?: string;
    message?: string;
    response?: unknown;
    request?: unknown;
  } | null;
  if (!err) return false;
  if (err.response !== undefined && err.response !== null) return false;
  if (err.code === 'ERR_NETWORK' || err.code === 'ECONNABORTED' || err.code === 'ETIMEDOUT') return true;
  return /network error|failed to fetch|load failed|networkerror|timeout/i.test(err.message ?? '');
}
